module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="cw-menu">\r\n\r\n</div>\r\n';
}
return __p;
};
